import { contact } from './contact';

export const privateLineHero = {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/707f97cc-15b5-4028-a4d2-416b44ac40b9.jpg',
  alt: 'The rain-speckled window of a chauffeured car at night, harbour lights blurred beyond the glass',
  title: 'Private Line',
  line: 'For members. At any hour, in any city — a single word is enough.',
};

export type Channel = {
  id: 'call' | 'whatsapp' | 'email' | 'sms';
  name: string;
  value: string;
  response: string;
  action: string;
  href: string;
};

export const channels: Channel[] = [
  {
    id: 'call',
    name: 'Call',
    value: contact.phoneDisplay,
    response: 'Answered by a partner, never a recording',
    action: 'Call now',
    href: contact.phoneHref,
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    value: contact.phoneDisplay,
    response: 'Replies within minutes, day or night',
    action: 'Open chat',
    href: `https://wa.me/${contact.whatsappNumber}`,
  },
  {
    id: 'email',
    name: 'Email',
    value: contact.email,
    response: 'For anything that can wait an hour',
    action: 'Write',
    href: `mailto:${contact.email}`,
  },
  {
    id: 'sms',
    name: 'Message',
    value: contact.phoneDisplay,
    response: 'When a call is not possible',
    action: 'Send a message',
    href: `sms:${contact.phoneHref.replace('tel:', '')}`,
  },
];

// One-tap requests — each opens WhatsApp with the words already written
export const quickRequests = [
  { label: 'A table, tonight', message: 'A table for tonight, please.' },
  { label: 'A car, now', message: 'I need a car, now. I will share my location.' },
  { label: 'A flight, today', message: 'I need to fly today.' },
  { label: 'A room, tonight', message: 'A suite for tonight, please.' },
  { label: 'Discretion required', message: 'A delicate matter. Please call me.' },
  { label: 'Security or medical', message: 'Urgent — security or medical assistance. Please call me immediately.' },
];

export const partnerCities = [
  { city: 'Dubai', timeZone: 'Asia/Dubai' },
  { city: 'Monaco', timeZone: 'Europe/Monaco' },
  { city: 'Hamburg', timeZone: 'Europe/Berlin' },
  { city: 'Ibiza', timeZone: 'Europe/Madrid' },
  { city: 'Warsaw', timeZone: 'Europe/Warsaw' },
];
